import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withXhr } from '@angular/common/http';

import * as ace from 'ace-builds';
ace.config.set('basePath', 'assets/ace');
import 'ace-builds/src-min/ace';
import 'ace-builds/src-min/mode-typescript';
import 'ace-builds/src-min/theme-monokai';

bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [...(appConfig.providers ?? []), provideHttpClient(withXhr())]
}).catch(err => console.error(err));
